export class DocumentHelper {
  static isValidCnpj(cnpj: string): boolean {
    if (!cnpj) return false;

    cnpj = cnpj.replace(/\D/g, '');

    if (cnpj.length !== 14) return false;

    const numbers = cnpj.substring(0, 12);
    const digits = cnpj.substring(12, 14);
    const weight = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let sum = 0;

    for (let i = 0; i < 12; i++) {
      sum += weight[i] * parseInt(numbers[i]);
    }

    const mod = sum % 11;

    if (mod < 2) {
      return parseInt(digits[0]) === mod;
    }
    return parseInt(digits[0]) === 11 - mod;
  }
}
